import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { extractErrorMessage } from "@Front/Utils/errorMessages";

export function logSetActiveOfficeFailure(error: unknown, userUid: string, officeUid: string): string {
	const { message: backendErrorMessage, status } = extractErrorMessage(error);
	const errorMessage =
		backendErrorMessage || (error instanceof Error ? error.message : "Erreur inconnue lors du changement d'office");

	LoggerService.error("❌ Erreur lors du changement d'office", {
		error,
		userUid,
		officeUid,
		errorMessage,
		backendErrorMessage,
		status,
	});

	return errorMessage;
}
